import type { components } from "@/api-schema";
import { getAppRoleV1Identifier } from "@/common/helpers/app-role-identifiers";
import { mapAttributeValueToName } from "@/common/helpers/map-attribute-value-to-name";
import { useMemo } from "react";

type AppRole = components["schemas"]["AppRole"];
type AppRoleAttribute = components["schemas"]["AppRoleAttribute"];

export function useFilteredRoles(roles: AppRole[], attributes: AppRoleAttribute[], searchTerm: string) {
  return useMemo(() => {
    const filteredRoles = roles.filter((role) =>
      `${role.name} ${getAppRoleV1Identifier(role) ?? ""}`.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    const filteredAttributes = attributes.filter((attribute) =>
      (mapAttributeValueToName(attribute.type) || attribute.type || "")
        .toLowerCase()
        .includes(searchTerm.toLowerCase()),
    );

    return {
      filteredRoles,
      filteredAttributes,
      totalFiltered: filteredRoles.length + filteredAttributes.length,
    };
  }, [roles, attributes, searchTerm]);
}
